export default __webpack_public_path__ + "static/47-fit-3753ac9eac9c7fec925121b7bb9e4ed5.png";